<template>
  <div class="client-search-filter">
    <v-row v-if="hasSubclients" align="center" class="mb-2">
      <v-col cols="12" :md="showIncludeSubclients ? 6 : 12">
        <v-autocomplete
          v-model="selectedClient"
          :items="clientsHierarchyList"
          item-title="displayName"
          item-value="id"
          :label="clientSelectLabel"
          clearable
          density="compact"
          variant="outlined"
          hide-details
          :loading="loadingClients"
          auto-select-first
          @focus="onAutocompleteFocus"
        ></v-autocomplete>
      </v-col>
      <v-col v-if="showIncludeSubclients" cols="12" md="6">
        <v-switch
          v-model="localIncludeSubclients"
          :label="localIncludeSubclients ? 'Include toti Subclienti' : 'Doar clienti directi'"
          color="primary"
          density="compact"
          hide-details
        ></v-switch>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { log } from "@/composables/useLog";
import { BASE_URL } from "@/composables/url_config";
import store from "@/store";

export default defineComponent({
  name: 'ClientSearchFilter',
  props: {
    modelValue: {
      type: [Number, String, null],
      default: null
    },
    includeSubclients: {
      type: Boolean,
      default: true
    },
    showIncludeSubclients: {
      type: Boolean,
      default: true
    },
    clientSelectLabel: {
      type: String,
      default: 'Selecteaza Client'
    },
    clientsHierarchy: {
      type: Array,
      default: null
    }
  },
  emits: ['update:modelValue', 'update:includeSubclients', 'hierarchy-loaded'],
  data() {
    return {
      loadingClients: false,
      internalClientsHierarchy: [],
      hasSubclients: false,
      currentClientId: null
    };
  },
  computed: {
    selectedClient: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    localIncludeSubclients: {
      get() {
        return this.includeSubclients;
      },
      set(val) {
        this.$emit('update:includeSubclients', val);
      }
    },
    clientsHierarchyList() {
      const hierarchy = this.clientsHierarchy || this.internalClientsHierarchy;
      const list = [];
      hierarchy.forEach(client => {
        const indent = client.level > 0 ? '\u2014'.repeat(client.level) + ' ' : '';
        list.push({
          id: client.id,
          name: client.name,
          displayName: indent + client.name,
          level: client.level,
          has_subclients: client.has_subclients
        });
      });
      return list;
    }
  },
  watch: {
    clientsHierarchy: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.hasSubclients = newVal.some(c => c.has_subclients);
        }
      }
    }
  },
  methods: {
    async loadClientsHierarchy() {
      if (this.clientsHierarchy) {
        this.hasSubclients = this.clientsHierarchy.some(c => c.has_subclients);
        return;
      }

      this.loadingClients = true;
      try {
        const token = store.getters.getToken;
        const response = await fetch(
          `${BASE_URL}/home/get_clients_hierarchy_api`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        const data = await response.json();
        if (!data.error) {
          this.internalClientsHierarchy = data.clients_hierarchy || [];
          this.hasSubclients = data.has_subclients || false;
          this.currentClientId = data.current_client_id;
          this.$emit('hierarchy-loaded', {
            hierarchy: this.internalClientsHierarchy,
            hasSubclients: this.hasSubclients,
            currentClientId: this.currentClientId
          });
        }
      } catch (err) {
        log("Error loading clients hierarchy:", err);
      } finally {
        this.loadingClients = false;
      }
    },
    onAutocompleteFocus(e) {
      if (this.modelValue) {
        const selected = this.clientsHierarchyList.find(c => c.id === this.modelValue);
        if (selected && e.target) {
          this.$nextTick(() => {
            e.target.value = selected.displayName;
            e.target.select();
          });
        }
      }
    },
    getSelectedClientInfo() {
      const hierarchy = this.clientsHierarchy || this.internalClientsHierarchy;
      return hierarchy.find(c => c.id === this.modelValue) || null;
    }
  },
  mounted() {
    if (!this.clientsHierarchy) {
      this.loadClientsHierarchy();
    }
  }
});
</script>

<style scoped>
.client-search-filter {
  width: 100%;
}
</style>
